import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { Member } from '@gem/call/CallStore/Member/Member';
import {
  PermissionsRequestStatuses,
  PermissionsTypes,
} from '@gem/call/Model/callPermissions/callPermissionsModel.types';
import { PERMISSIONS_REQUEST_TYPES } from '@gem/call/constants';

import { IPermissionRequestItemProps } from './PermissionRequestItem.types';

interface IPermissionRequestItemPresenter {
  onAction(status: PermissionsRequestStatuses): void;
  userId: string;
  permissionType: PermissionsTypes;
  ongoingCall: Call;
  channelId: string | null;
  member: Member | null;
  approve(): void;
  reject(): void;
}

export const usePermissionRequestItemPresenter = (
  props: IPermissionRequestItemProps
): IPermissionRequestItemPresenter => {
  const presenter = useLocalObservable<IPermissionRequestItemPresenter>(() => ({
    userId: props.userId,
    permissionType: props.permissionType,

    onAction(status: PermissionsRequestStatuses): void {
      if (presenter.channelId) {
        props.callController.updatePermissionRequestForUser({
          channelId: presenter.channelId,
          access: PERMISSIONS_REQUEST_TYPES[presenter.permissionType],
          status,
          userId: presenter.userId,
        });
      }
    },

    approve(): void {
      presenter.onAction(PermissionsRequestStatuses.Approved);
    },

    reject(): void {
      presenter.onAction(PermissionsRequestStatuses.Rejected);
    },

    get ongoingCall(): Call {
      return props.call;
    },

    get member(): Member | null {
      return presenter.ongoingCall.members.getMemberById(props.userId);
    },

    get channelId(): string | null {
      return presenter.ongoingCall.channelId || null;
    },
  }));

  useEffect(() => {
    presenter.userId = props.userId;
    presenter.permissionType = props.permissionType;
  }, [props.userId, props.permissionType]);
  return presenter;
};
